import React from "react";

import { SignUpVersion } from "scenes/Authentication/components/SignUpVersion";

import PrivacyPolicyModalDefault from "./PrivacyPolicyModal";

export function PrivacyPolicyModal(props) {
  return (
    <SignUpVersion>
      <PrivacyPolicyModalDefault {...props} />
    </SignUpVersion>
  );
}

export default PrivacyPolicyModal;
